import Api from "./Api";
import { WidgetOutboundMessage } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class WidgetOutboundMessagesController extends Api {
  static getForm(widgetId: string, outboundMessageId?: string) {
    const idParam = outboundMessageId ? `/${outboundMessageId}` : ''
    return fetch(`/api/widgets/${widgetId}/outbound_messages${idParam}/form`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: this.token,
      },
      credentials: 'same-origin',
    }).then((res) => res.json())
  }

  static getOutboundMessages(widgetId: string, params: object = {}) {
    return fetch(
      `/api/widgets/${widgetId}/outbound_messages?${SearchHelper.getQueryString(params)}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static create(widgetId: string, outboundMessage: Partial<WidgetOutboundMessage>) {
    return fetch(`/api/widgets/${widgetId}/outbound_messages`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ outbound_message: outboundMessage }),
    }).then((res) => res.json());
  }

  static update(widgetId: string, outboundMessage: Partial<WidgetOutboundMessage>) {
    return fetch(`/api/widgets/${widgetId}/outbound_messages/${outboundMessage.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ outbound_message: outboundMessage }),
    }).then((res) => res.json());
  }

  static delete(widgetId: string, id: string) {
    return fetch(`/api/widgets/${widgetId}/outbound_messages/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static deleteAll(widgetId: string, ids: string[]) {
    return fetch(`/api/widgets/${widgetId}/outbound_messages/destroy_all`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ ids }),
    }).then((res) => res.json());
  }
}
